/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import updating from '../../lib/api/updating';
import FullScreenSpinner from '../../components/FullScreenSpinner';

const Updating: React.FC = function Updating() {
  const navigate = useNavigate();
  const { token } = useParams();

  const { isLoading } = useQuery({
    queryKey: ['user-job-post'],
    queryFn: () => updating(token!),
    enabled: !!token,
  });

  useEffect(() => {
    navigate('/profilo');
  }, [isLoading]);

  return <div>{isLoading && <FullScreenSpinner />}</div>;
};

export default Updating;